import { render, staticRenderFns } from "./OPSDashboard.vue?vue&type=template&id=0c768c6b&scoped=true&"
import script from "./OPSDashboard.vue?vue&type=script&lang=js&"
export * from "./OPSDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OPSDashboard.vue?vue&type=style&index=0&id=0c768c6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c768c6b",
  null
  
)

export default component.exports